module.exports = __webpack_public_path__ + "static_pc/img/googleBT.71e493a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/googleBT.png
// module id = CpQv
// module chunks = 1